import { render, staticRenderFns } from "./ConsoleSettings.vue?vue&type=template&id=a0aa3714&"
import script from "./ConsoleSettings.vue?vue&type=script&lang=ts&"
export * from "./ConsoleSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports